import React from 'react';
import {ReactComponent as IconClose} from '../svgs/close.svg';
import {ReactComponent as IconModal} from '../svgs/modal.svg';


export default function ModalWindow({msg, closeModal}){  

    let modal_window_content

    if(msg.length > 1) {
        modal_window_content = (
            <div>
                <audio src="/audio/push.mp3" autoplay="autoplay"></audio>
                <div className="modal_empty" onClick={() => closeModal()}></div>
                <div className="modal_window">
                    <div className="close_elementPage" onClick={() => closeModal()}><IconClose/></div>
                    <div className="modal_content_icon"><IconModal/></div>
                    <div className="modal_content"> {msg} </div>
                </div>
            </div>
        )
    }
    else modal_window_content = ''

    return modal_window_content

}